// Third-party Library
import { Modal, Button } from "antd"

// components
import { PrimaryButton } from "../../Decoration/Button"
import SVG from "../../SVG"

// style 
// import styles from './index.module.css'

const ModalContent = (props) => {
    const {
        icon = 
            <SVG 
                name={`warning-blue`}
                viewBox="0 0 35 35" 
                fill="none" 
                size="50"
            />,
        title = 'popup title',
        content = 'popup content',
        subcontent = ''
    } = props

    return (
        <div style={{ padding: '.2em .5em 0 .2em', textAlign: 'center' }}>
            {
                icon && ((typeof icon === 'string') && <img src={icon} style={{ marginBottom: '20px', height: '50px' }} alt='icon' /> || icon)
            }
            <h3>{title}</h3>
            <p>{content}</p>
            <p>{subcontent}</p>
        </div>
    )
}

const ModalFooter = ({ onClick, onCancel }) => {
    return (
        <div className={'v-center'} style={{ gap: '1em' }}>
            <Button onClick={onCancel} style={{ padding: '1.6em', backgroundColor: '#ED5B57', color: '#fff'}}>Cancel</Button>
            <PrimaryButton onClick={onClick} mode='primary' style={{ padding: '1.6em'}}>Yes</PrimaryButton>
        </div>
    )
}

/**
 * 
 * Main render
 * 
 */
const ModalContentWrapper = ({
    onOk = () => {},
    open = false,
    onCancel = () => {},
    ...props
}) => {

    return (
        <Modal
            open={open}
            onCancel={onCancel}
            closable={false}
            footer={<ModalFooter onCancel={onCancel} onClick={onOk}/>}
            width={400}
        >
            { ModalContent(props) }
        </Modal>
    )
}

export default ModalContentWrapper